import { render, staticRenderFns } from "./CryoProcessingContent.vue?vue&type=template&id=0e4b48da"
import script from "./CryoProcessingContent.vue?vue&type=script&lang=js"
export * from "./CryoProcessingContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports